import React, { FC } from 'react';
import { FooterLinkModel } from '../../../../models/footerLink.model';
import { TFooterLink } from '../../../../types/footerLink.types';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import './styles.scss';

const MarketSelector: FC<TFooterLink> = (props) => {
  const model = new FooterLinkModel(props);

  return (
    <div className="market-selector">
      <div className="market-selector__container">
        <RoutableNotEditableLink className="market-selector__link" href={model?.link?.value?.href ?? ''} onClick={props?.onclick}>
          <Icon extraClassName="market-selector__left-icon" iconName="social-sharing-globe" size={iconSize.mbl} />
          <span className='market-selector__link-title'>{model?.title?.value}</span>
          <Icon extraClassName="market-selector__right-icon" iconName="arrow-chevron-right" size={iconSize.mbl} />
        </RoutableNotEditableLink>
      </div>
    </div>
  );
};

export default MarketSelector;
